module.exports = __webpack_public_path__ + "img/footer2.16b5572c.png";